import type { ReactNode } from 'react'

import Body from './body'
import Footer from './footer'
import Header from './header'

import '@hotmart/cosmos/dist/card/card.css'

type CardProps = {
  children: ReactNode
  className?: string
  'data-test'?: string
}

const Card = ({ children, className = '', 'data-test': dataTest = '' }: CardProps) => {
  return (
    <hot-card class={className} data-test={dataTest}>
      {children}
    </hot-card>
  )
}

Card.Header = Header
Card.Body = Body
Card.Footer = Footer

export default Card
